import type { ButtonHTMLAttributes, ReactNode } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled,
  children,
  className,
  ...rest
}: ButtonProps) {
  const classes = [
    "rp-btn",
    `rp-btn--${variant}`,
    `rp-btn--${size}`,
    loading && "rp-btn--loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button {...rest} disabled={disabled || loading} className={classes}>
      {loading ? <span className="rp-btn__spinner" aria-hidden="true" /> : null}
      <span className="rp-btn__label">{children}</span>
    </button>
  );
}
